import React from 'react';
import { Outlet } from 'react-router';
import { GUEST_PATH } from '../../../../constants';

const Checkout = React.lazy(() => import('./index'));
const PaymentSuccess = React.lazy(() => import('./PaymentSuccess'));

const routes = {
     path: GUEST_PATH.CHECKOUT,
     breadcrumb: 'Checkout',
     element: <Outlet />,
     children: [
          { index: true, element: <Checkout /> },
          { path: GUEST_PATH.PAYMENT_SUCCESS, breadcrumb: 'Payment Success', element: <PaymentSuccess /> },
     ],
};

export default routes;
